module.exports = __webpack_public_path__ + "media/St 4-thermostat2-hint.e9d4a99b.wav";